import { createSelector } from 'reselect';
import { AppState } from '../../reducers';
import { UserOnHome } from '../../../types/user/user.def';

const selectUser = (state: AppState) => state.user;

export const getChallengeStatus = createSelector(selectUser, user => {
  if (user.classe) {
    const debut = user.classe.debut;
    const fin = user.classe.fin;
    const now = new Date();
    if (new Date(debut) > now)
      return {
        status: 'notStarted',
        starting: debut,
        ending: fin
      };
    if (new Date(fin) < now)
      return {
        status: 'ended',
        starting: debut,
        ending: fin
      };
    else
      return {
        status: 'available',
        starting: debut,
        ending: fin
      };
  }
  return {
    status: 'Aucune classe'
  };
});

export const getUserSidebar = createSelector(selectUser, user => ({
  firstname: user.firstname,
  lastname: user.lastname,
  avatar: user.avatar,
  role: user.role,
  lycee: {
    name: user.classe && user.classe.lycee.name,
    ville: user.classe && user.classe.lycee.ville
  }
}));

export const getUserClasse = createSelector(selectUser, user => user.classe);

export const getUserNotifications = createSelector(
  selectUser,
  user => user.options?.notifications || []
);

export const getNotificationsReadIds = createSelector(
  getUserNotifications,
  notifications => notifications.map(notif => notif)
);

export const getUserName = createSelector(selectUser, user => user.username);

export const getFirstName = createSelector(selectUser, user => user.firstname);

export const getIfIsPairTeacher = createSelector(
  selectUser,
  user => user.isPairTeacher
);

const roleForUserZohoForm = role => {
  switch (role) {
    case 'professeur':
      return 'Professeur';
    case 'eleve':
      return 'Élève';
  }
};

export const getUserZohoForm = createSelector(
  selectUser,
  (user: UserOnHome) => ({
    Name_First: user.firstname,
    Name_Last: user.lastname,
    Email: user.email,
    Dropdown1: roleForUserZohoForm(user.role)
  })
);
